var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _vm.displayMode == "grid"
        ? _c("div", [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn blue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.multiSelectMode = !_vm.multiSelectMode
                    },
                  },
                },
                [
                  _vm.multiSelectMode
                    ? _c("span", [
                        _c("i", { staticClass: "fa fa-check-square-o" }),
                      ])
                    : _c("span", [_c("i", { staticClass: "fa fa-square-o" })]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Sélection multiple")]),
                ]
              ),
              _vm._v(" "),
              _vm.selectedFiles.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn purple",
                      attrs: { type: "button" },
                      on: { click: _vm.viewSelectedFilesPrompt },
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" "),
                      _vm.selectedFiles.length > 1
                        ? _c("span", [
                            _vm._v(
                              "Voir " +
                                _vm._s(_vm.selectedFiles.length) +
                                " documents"
                            ),
                          ])
                        : _c("span", [_vm._v("Voir le document")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedFiles.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn red",
                      attrs: { type: "button" },
                      on: { click: _vm.deleteSelectedFilesPrompt },
                    },
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(" "),
                      _vm.selectedFiles.length > 1
                        ? _c("span", [
                            _vm._v(
                              "Supprimer " +
                                _vm._s(_vm.selectedFiles.length) +
                                " documents"
                            ),
                          ])
                        : _c("span", [_vm._v("Supprimer le document")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedFiles.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn orange",
                      attrs: { type: "button" },
                      on: { click: _vm.downloadSelectedFiles },
                    },
                    [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v(" "),
                      _vm.selectedFiles.length > 1
                        ? _c("span", [
                            _vm._v(
                              "Télécharger " +
                                _vm._s(_vm.selectedFiles.length) +
                                " documents"
                            ),
                          ])
                        : _c("span", [_vm._v("Télécharger le document")]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2" },
              [
                _vm._l(_vm.files, function (file, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "text-center file-item",
                      class: {
                        "file-multi-select": _vm.multiSelectMode,
                        selected: _vm.fileSelected(file),
                      },
                      staticStyle: {
                        width: "125px",
                        display: "inline-block",
                        "vertical-align": "top",
                        position: "relative",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSelected($event, file)
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c("div", { staticClass: "file-thumbnail" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.fileThumbnail(file),
                              alt: file.name,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "file-title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(file.name) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-select-box" }, [
                        _vm.fileSelected(file)
                          ? _c("span", [
                              _c("i", { staticClass: "fa fa-check-square-o" }),
                            ])
                          : _c("span", [
                              _c("i", { staticClass: "fa fa-square-o" }),
                            ]),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.editEnabled
                  ? _c(
                      "div",
                      {
                        staticClass: "display: inline-block",
                        staticStyle: {
                          width: "125px",
                          height: "125px",
                          "vertical-align": "top",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "add-document-button",
                            on: { click: _vm.triggerFileUpload },
                          },
                          [_c("i", { staticClass: "fa fa-plus" })]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm.displayMode == "list"
        ? _c("div", [
            _c("table", { staticClass: "table table-bordered" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Date")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Nom")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticStyle: { width: "1%", "white-space": "nowrap" } },
                    [
                      _vm.editEnabled
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm blue",
                              staticStyle: { width: "100%" },
                              on: { click: _vm.triggerFileUpload },
                            },
                            [_vm._v("Ajouter")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.files.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.files, function (file, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticStyle: { "white-space": "nowrap" } }, [
                          _vm._v(_vm._s(file.date)),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(file.name))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "1%",
                              "white-space": "nowrap",
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-circle btn-icon-only btn-default tooltips",
                                attrs: {
                                  "data-container": "body",
                                  "data-placement": "top",
                                  "data-original-title": "Télécharger",
                                  href: "javascript:;",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadOneDocument(file)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "glyphicon glyphicon-download",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-circle btn-icon-only btn-default tooltips",
                                attrs: {
                                  "data-container": "body",
                                  "data-placement": "top",
                                  "data-original-title": "Supprimer",
                                  href: "javascript:;",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteOneDocument(file)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-trash" })]
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [_vm._m(0)]),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "uploader" }, [
      _c("input", {
        ref: "file-uploader",
        attrs: { type: "file", multiple: "" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "text-center", attrs: { colspan: "3" } }, [
        _vm._v("Aucun documents"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }